import React from "react";

const defaultrecycledData = [
  {
    indicateinput: "",
    recycledmaterial: "",
  },
];

const RecycledMaterialTable = ({ recycledData, setRecycledData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...recycledData];
    updated[index][field] = value;
    setRecycledData(updated);
  };

  const addRow = () => {
    setRecycledData([
      ...recycledData,
      { inputMaterial: "", currentFY: "", previousFY: "" },
    ]);
  };

  const removeRow = (index) => {
    const updated = [...recycledData];
    updated.splice(index, 1);
    setRecycledData(updated);
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          overflowX: "auto",
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
              <th rowSpan="2" style={tableHeaderStyle}>
                Indicate input material
              </th>
              <th colSpan="2" style={tableHeaderStyle}>
                Recycled or reused material in total material
              </th>
            </tr>
            <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
              <th style={tableHeaderStyle}>Current FY</th>
              <th style={tableHeaderStyle}>Previous FY</th>
            </tr>
          </thead>
          <tbody>
            {recycledData.map((row, index) => (
              <tr key={index}>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="Input material"
                    value={row.inputMaterial}
                    onChange={(e) =>
                      handleChange(index, "inputMaterial", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="Current FY"
                    value={row.currentFY}
                    onChange={(e) =>
                      handleChange(index, "currentFY", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="Previous FY"
                    value={row.previousFY}
                    onChange={(e) =>
                      handleChange(index, "previousFY", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        <button onClick={addRow} style={addButtonStyle}>
          + Add Row
        </button>
        {recycledData.length > 1 && (
          <button
            onClick={() => removeRow(recycledData.length - 1)}
            style={removeButtonStyle}
          >
            - Remove
          </button>
        )}
      </div>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "16px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const inputStyle = {
  width: "100%",
  padding: "20px",
  minHeight: "48px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  textAlign: "center",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default RecycledMaterialTable;
